var r=function(r){var a=-1,n=Array(r.size);return r.forEach((function(r,t){n[++a]=[t,r]})),n};export{r as default};
//# sourceMappingURL=_mapToArray.js.map
